// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"6c52b3cd","161":"7d613a68","209":"e1f55257","478":"525447d1","625":"9120f5af","716":"f6c6cc3a","745":"4cdb9fc4","922":"a9748d02","964":"6ec9386d"}[chunkId] + ".chunk.js";
};